import { spinnerCaptionEl, spinnerEl } from "./elements";

const MIN_SPINNING_TIME = 0;
const MIN_SPINNING_TIME_CAPTION = 2000;

export const withSpinner = (promise, caption = "") => {
  const minSpinningTime = caption
    ? MIN_SPINNING_TIME_CAPTION
    : MIN_SPINNING_TIME;
  spinnerEl.style.display = "block";
  spinnerCaptionEl.innerHTML = caption;
  if (caption) spinnerEl.style.backgroundColor = "rgba(0, 0, 0, 0.6)";
  else spinnerEl.style.backgroundColor = "rgba(0, 0, 0, 0.4)";
  const now = new Date();
  return promise.finally(() => {
    const deltaTime = new Date() - now;
    if (deltaTime < minSpinningTime)
      setTimeout(hideSpinner, minSpinningTime - deltaTime);
    else hideSpinner();
  });
};

function hideSpinner() {
  spinnerEl.style.display = "none";
}
